import type { SxProps, Theme } from "@mui/material/styles";

import type { PartyShellPalette } from "../theme/theme";

/** Mui TextField on dark party shells — high-contrast input text (not browser default blue). */
export function partyOutlinedFieldSx(
  partyPal: PartyShellPalette,
): SxProps<Theme> {
  return {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      fontFamily: "var(--font-body)",
      color: partyPal.ink,
      backgroundColor: "rgba(255,255,255,0.05)",
      "& fieldset": { borderColor: partyPal.inkFaint },
      "&:hover fieldset": { borderColor: partyPal.inkDim },
      "&.Mui-focused fieldset": { borderColor: partyPal.hot },
    },
    "& .MuiOutlinedInput-input, & .MuiInputBase-inputMultiline": {
      color: partyPal.ink,
      WebkitTextFillColor: partyPal.ink,
    },
    "& .MuiInputLabel-root": { color: partyPal.inkDim },
    "& .MuiInputLabel-root.Mui-focused": { color: partyPal.hot },
    "& .MuiInputBase-input::placeholder": {
      color: partyPal.hot,
      opacity: 0.9,
      WebkitTextFillColor: `${partyPal.hot}`,
    },
    "& .MuiFormHelperText-root": { color: partyPal.inkDim },
  };
}

/** Bluff answer step: strong outline at rest + pink typed text (on card or dark shell). */
export function partyBluffAnswerFieldSx(
  partyPal: PartyShellPalette,
): SxProps<Theme> {
  const pink = partyPal.hot;
  return {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      fontFamily: "var(--font-body)",
      color: pink,
      backgroundColor: "rgba(0,0,0,0.12)",
      "& fieldset": {
        borderWidth: 2,
        borderColor: pink,
      },
      "&:hover fieldset": {
        borderWidth: 2,
        borderColor: pink,
      },
      "&.Mui-focused fieldset": {
        borderWidth: 2,
        borderColor: pink,
      },
      "&.Mui-disabled fieldset": {
        borderColor: `${partyPal.inkFaint}`,
      },
      "&.Mui-error fieldset": {
        borderWidth: 2,
        borderColor: pink,
      },
      "&.Mui-error:hover fieldset": {
        borderWidth: 2,
        borderColor: pink,
      },
      "&.Mui-error.Mui-focused fieldset": {
        borderWidth: 2,
        borderColor: pink,
      },
    },
    "& .MuiOutlinedInput-input, & .MuiInputBase-inputMultiline": {
      color: pink,
      WebkitTextFillColor: pink,
      caretColor: pink,
    },
    "& .MuiInputLabel-root": { color: partyPal.inkDim },
    "& .MuiInputLabel-root.Mui-focused": { color: pink },
    "& .MuiInputBase-input::placeholder": {
      color: partyPal.hot,
      opacity: 0.95,
      WebkitTextFillColor: `${partyPal.hot}`,
    },
    "& .MuiFormHelperText-root": { color: partyPal.inkDim },
    "& .MuiFormHelperText-root.Mui-error": {
      color: pink,
      fontWeight: 700,
      fontSize: 13,
      lineHeight: 1.4,
    },
  };
}
